import React, { useCallback, useState } from 'react';
import { StyledButtonGroup, StyledSelectElement, StyledLabel } from './styled';
function getOrder(index, count) {
    if (index === 0)
        return 'first';
    if (index === count - 1)
        return 'last';
    return `${index}`;
}
const SelectElement = ({ id, title, select, isActive, order }) => {
    const onClick = useCallback(() => select(id), [id]);
    return (React.createElement(StyledSelectElement, { onClick: onClick, isActive: isActive, order: order, "data-testid": `radio-group-button-${order}` },
        React.createElement(StyledLabel, null, title)));
};
export const SelectGroupButtons = ({ items, selected, onSelect }) => {
    const [selectedId, select] = useState(selected);
    const onSelectHandler = useCallback((id) => {
        select(id);
        onSelect && onSelect(id);
    }, [select, onSelect]);
    return (React.createElement(StyledButtonGroup, null, items.map(({ id, label }, index) => (React.createElement(SelectElement, { key: id, id: id, select: onSelectHandler, isActive: id === selectedId, title: label, order: getOrder(index, items.length) })))));
};
